import { IPlan } from '../../../services/decoders/planDecoder'
import { useQuery } from '@tanstack/react-query'
import { getUserPlansByProductId } from '../../../services/planAPI'

/**
 * Namespaced away from the bare ['plans', productId] this used to share with an all-plans query.
 * The query cache is persisted to localStorage for 24 hours, so that key can still be holding an
 * every-plan-in-the-product response written before the backend became the only entitlement
 * gate; a fresh key is what stops it being served back to a client.
 */
export const userPlansQueryKey = (productId?: string) => [
  'plans',
  'entitled',
  productId,
]

export const useFetchUserPlansQuery = ({ productId }: { productId?: string }) =>
  useQuery<IPlan[]>({
    queryKey: userPlansQueryKey(productId),
    queryFn: () => getUserPlansByProductId(productId),
    enabled: !!productId,
    refetchOnWindowFocus: false,
  })
